import { render, staticRenderFns } from "./categoryMgt.vue?vue&type=template&id=0898f0ff&scoped=true&"
import script from "./categoryMgt.vue?vue&type=script&lang=js&"
export * from "./categoryMgt.vue?vue&type=script&lang=js&"
import style0 from "./categoryMgt.vue?vue&type=style&index=0&id=0898f0ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0898f0ff",
  null
  
)

component.options.__file = "categoryMgt.vue"
export default component.exports